import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ENDPOINT } from "../../../services/api/resources";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import classes from "./ThreeWayMatching.module.css";
import Dbutton from "../../../components/Dashboard/DashboardButtons/Dbutton";
import plusIcon from "../../../assets/images/svg/plusIcon.png";
import SearchBar from "../../../components/common/SearchBar/SearchBar";
import { MoreHoriz } from "@mui/icons-material";
import DButtonOutlined from "../../../components/Dashboard/DashboardButtons/dButtonOutlined";
import DTextInput from "../../../components/Dashboard/DashboardInputs/DTextInput";
import SelectCountry from "../../../components/Dashboard/amount/SelectCountry";
import { Autocomplete, Box, Fade, Grid, Modal, TextField } from "@mui/material";
import { CurrencyContext } from "../../../context/CurrencyContext";
import { emptyCheck } from "../../../utils/validations";
import PopupFrame from "../../../components/Popups/PopupFrame/PopupFrame";
import { getUniqueData } from "../../../utils/getUniqueData";
import DataTable from "../../../components/common/DataTable/DataTable";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import InfoLabel from "../../../components/common/InfoLabel/InfoLabel";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";

export default function TWMSlabConfig() {
  const loginData = useSelector((state) => state.loginData.value);
  const [auth_token] = useState(loginData?.auth_token);
  const [user_token] = useState(loginData?.user?.token);

  const [openapprovalmodal, setOpenApprovalModal] = useState(false);
  const [successpopup, setSuccessPopUp] = useState(false);
  const [openViewItemPopup, setOpenViewItemPopup] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);

  const [getuserlist, setUserList] = useState([]);
  const [selectedApprovers, setSelectedApprovers] = useState([]);
  const [approvers, setApprovers] = useState([]);
  const [configUsers, setConfigUsers] = useState([]);

  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentList, setDepartmentList] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const [uniqueData, setUniqueData] = useState();
  const { fromCurrency, setFromCurrency } = useContext(CurrencyContext);

  const [startPrice, setStartPrice] = useState({
    value: "",
    isValid: true,
  });
  const [endPrice, SetEndPrice] = useState({
    value: "",
    isValid: true,
  });
  const [stageName, setStageName] = useState({
    value: "",
    isValid: true,
  });

  const [getsavedposlab, setSavedPOSlab] = useState([]);

  const [editSlabId, setEditSlabId] = useState(null);

  const getAllUserList = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.all_user_list}`,
        { buyer_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      const filteredUsers = response?.data
        .filter((user) => user.token !== user_token)
        .filter((user) => user.department === "Finance");

      setUserList(filteredUsers);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const getAllDepartment = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_Department}`,
        { user_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      setDepartmentList(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching user list:", error);
    }
  };

  const handleGetTWMslab = async () => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT.get_all_twm_slab}`,
        { admin_token: user_token },
        { headers: { Authorization: `Bearer ${auth_token}` } }
      );

      setConfigUsers(response.data.response);
    } catch (error) {
      console.log("error");
    }
  };

  useEffect(() => {
    getAllUserList();
    getAllDepartment();
    handleGetTWMslab();
  }, []);

  const handleOpenAddItem = () => {
    setOpenApprovalModal(true);
  };

  const resetFormFields = () => {
    setStageName({ value: "", isValid: true });
    setStartPrice({ value: "", isValid: true });
    SetEndPrice({ value: "", isValid: true });
    // setFromCurrency({
    //     currency: "",
    //     countryName: ""
    // });
    setSelectedApprovers([]);
    setApprovers([]);
  };

  const handleCloseAddItem = () => {
    resetFormFields();
    setOpenApprovalModal(false);
    setIsEditMode(false);
  };

  const viewUserHeading = (
    <HeaderTitle
      titleText={"Add Slab Range" || <MoreHoriz sx={{ fontSize: "30px" }} />}
      customclass={classes.heading_pop_pup}
    />
  );

  const handleTWMdata = async () => {
    let isValid = true;

    if (!stageName.value.trim()) {
      setStageName((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      setStageName((prev) => ({ ...prev, isValid: true }));
    }

    if (!startPrice.value) {
      setStartPrice((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      setStartPrice((prev) => ({ ...prev, isValid: true }));
    }

    if (
      !endPrice.value ||
      parseFloat(endPrice.value) < parseFloat(startPrice.value)
    ) {
      SetEndPrice((prev) => ({ ...prev, isValid: false }));
      isValid = false;
    } else {
      SetEndPrice((prev) => ({ ...prev, isValid: true }));
    }

    if (!isValid) return;

    try {
      const level1UserTokens = selectedApprovers.map((user) => user.token);
      const levelNUserTokens = approvers
        .map((approver) => approver.value)
        .filter(Boolean);
      const allUserTokens = [...level1UserTokens, ...levelNUserTokens];

      const formData = new FormData();
      formData.append("stage_name", stageName.value);
      formData.append("price_start", startPrice.value);
      formData.append("price_end", endPrice.value);
      formData.append("currency", fromCurrency.currency || "");
      formData.append("country_name", fromCurrency.countryName || "");
      formData.append("users", JSON.stringify(allUserTokens));
      formData.append("admin_token", user_token);
      formData.append("dept_name", selectedDepartment?.name || "");

      if (isEditMode && editSlabId) {
        formData.append("id", editSlabId);
      }

      const response = await axios.post(
        API_ENDPOINT.ins_twm_slab_config,
        formData,
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSuccessPopUp(true);
      }
    } catch (error) {
      console.error(
        "Error saving PR slab:",
        error.response?.data || error.message
      );
      alert("Something went wrong while saving the slab.");
    }
  };

  const viewTextActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseAddItem}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <Dbutton
      label={`${isEditMode ? "Update" : "Submit"}`}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleTWMdata}
      // disabled={sendmsg && !errorMessages}
    />,
  ];

  const handleAddApprover = () => {
    const updated = [...approvers];
    if (updated.length > 0) {
      updated[updated.length - 1].showAdd = false;
    }
    updated.push({ id: approvers.length + 1, value: "", showAdd: true });
    setApprovers(updated);
  };

  const handleRemoveApprover = (id) => {
    const updated = approvers.filter((item) => item.id !== id);
    if (updated.length > 0) {
      updated[updated.length - 1].showAdd = true;
    }
    setApprovers(updated);
  };

  const renderApproverInputs = () => {
    approvers.map((approver, index) => (
      <div
        key={approver.id}
        style={{ marginBottom: "1rem", display: "flex", gap: "1rem" }}
      >
        <Autocomplete
          disablePortal
          options={getuserlist}
          sx={{ width: 300 }}
          getOptionLabel={(option) =>
            `${option.first_name}-${option.designation || ""}`
          }
          value={getuserlist.find((u) => u.token === approver.value) || null}
          onChange={(event, newValue) => {
            const updated = [...approvers];
            updated[index].value = newValue?.token || "";
            setApprovers(updated);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={`Approver ${index + 2}`}
              placeholder="Choose user"
            />
          )}
        />
        {approver.showAdd ? (
          <Dbutton label="Add" onClick={handleAddApprover} btnHeight="3.5rem" />
        ) : (
          <DButtonOutlined
            label="Remove"
            onClick={() => handleRemoveApprover(approver.id)}
            btnHeight="3.5rem"
          />
        )}
      </div>
    ));
  };

  const PoslabItemInputs = [
    <Grid container spacing={2} key="twm-slab-grid">
      {/* Row 1: Stage Name full width */}
      <Grid item xs={12}>
        <DTextInput
          label="Stage Name"
          type="text"
          value={stageName.value}
          onChange={(e) =>
            setStageName({
              value: e.target.value,
              isValid: emptyCheck(e.target.value),
            })
          }
          error={!stageName.isValid}
          customClassName={classes.popupFields}
          errorMsg="Stage Name is required"
        />
      </Grid>

      {/* Row 2: Start / End Price side-by-side */}
      <Grid item xs={12} md={6}>
        <DTextInput
          label="Start Price"
          type="number"
          value={startPrice.value}
          onChange={(e) =>
            setStartPrice({
              value: e.target.value,
              isValid: emptyCheck(e.target.value),
            })
          }
          error={!startPrice.isValid}
          customClassName={classes.popupFields}
          errorMsg="Start Price required"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <DTextInput
          label="End Price"
          type="number"
          value={endPrice.value}
          onChange={(e) =>
            SetEndPrice({
              value: e.target.value,
              isValid: emptyCheck(e.target.value),
            })
          }
          error={!endPrice.isValid}
          customClassName={classes.popupFields}
          errorMsg={
            endPrice.value !== "" &&
            Number(endPrice.value) <= Number(startPrice.value)
              ? "End Price should not be lesser than Start Price"
              : "End Price required"
          }
        />
      </Grid>

      {/* Row 3: Department full width */}
      {/* <Grid item xs={12}>
                <Autocomplete
                    disablePortal
                    options={departmentList}
                    getOptionLabel={(option) => option?.name || ""}
                    value={selectedDepartment}
                    onChange={(e, newVal) => setSelectedDepartment(newVal)}
                    renderInput={(params) => (
                        <TextField {...params} label="Department" placeholder="Select department" sx={{
                            '& .MuiInputBase-root': { fontSize: '14px' },
                            '& .MuiInputLabel-root': { fontSize: '14px' },
                            '& .MuiAutocomplete-tag': { fontSize: '12px' },
                        }} />
                    )}
                />
            </Grid> */}

      {/* Row 4: Approvers full width */}
      <Grid item xs={12}>
        <Autocomplete
          multiple
          disablePortal
          options={getuserlist}
          getOptionLabel={(option) =>
            option
              ? `${option.first_name || "N/A"} - ${option.designation || ""}`
              : ""
          }
          value={selectedApprovers}
          onChange={(event, newValue) => setSelectedApprovers(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Approvers"
              placeholder="Choose user(s) to approve"
              sx={{
                "& .MuiInputBase-root": { fontSize: "14px" },
                "& .MuiInputLabel-root": { fontSize: "14px" },
                "& .MuiAutocomplete-tag": { fontSize: "12px" },
              }}
            />
          )}
        />
      </Grid>

      {/* Row 5: Dynamic approver fields */}
      <Grid item xs={12}>
        {renderApproverInputs()}
      </Grid>
    </Grid>,
  ];

  const Tableheadings = [
    { label: "Name", field: "slab_name" },
    { label: "Users", field: "users" },
    // { label: "Department", field: "department" },
    // { label: "Currency", field: "currency_type" },
    { label: "Start Price", field: "price_start" },
    { label: "End Price", field: "price_end" },
  ];

  const itemsData = configUsers;

  const processedItemsData = itemsData.map((item) => ({
    ...item,
    usersList: item.users, // keep original object array for modal
    users: item.users.map((user) => user.approver_name).join(", "), // string for table
  }));

  const handleBack = () => {
    resetFormFields();
    handleGetTWMslab();
    setSuccessPopUp(false);
    setOpenApprovalModal(false);
    setIsEditMode(false);
  };

  const handleCloseViewItemPopup = () => {
    setOpenViewItemPopup(false);
  };

  const filteredData = processedItemsData.filter((item) => {
    if (!searchQuery) return true;

    const query = searchQuery.toLowerCase();
    return (
      (item.slab_name && item.slab_name.toLowerCase().includes(query)) ||
      (item.users && item.users.toLowerCase().includes(query)) ||
      (item.price_start && item.price_start.toString().includes(query)) ||
      (item.price_end && item.price_end.toString().includes(query))
    );
  });

  useEffect(() => {
    const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
    if (!chatActionRaw) return;

    const { action, buyerAdmin_approverRange_search } =
      JSON.parse(chatActionRaw);

    if (action === "search_twm_approver_range") {
      if (!filteredData || filteredData.length === 0) return;

      console.log(buyerAdmin_approverRange_search?.searchText);
      setSearchQuery(buyerAdmin_approverRange_search?.searchText || "");

      sessionStorage.removeItem("CHAT_ACTION");
    }

    if (action === "add_twm_approver_range") {
      handleOpenAddItem();
    }
  }, [filteredData]);

  const viewItemsActionButtons = [
    <DButtonOutlined
      label={"Cancel"}
      onClick={handleCloseViewItemPopup}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
    />,
    <Dbutton
      label={"OK"}
      btnWidth={"17rem"}
      btnHeight={"4rem"}
      onClick={handleCloseViewItemPopup}
    />,
  ];

  const viewUserChildren = [
    <InfoLabel
      size={"44%"}
      label={"Stage Name"}
      value={uniqueData?.slab_name}
    />,
    <InfoLabel
      size={"44%"}
      label={"Start price"}
      value={uniqueData?.price_start}
    />,
    <InfoLabel
      size={"44%"}
      label={"End Price"}
      value={uniqueData?.price_end}
    />,
    <InfoLabel
      size={"44%"}
      label={"Approvers"}
      value={
        uniqueData?.usersList ? (
          <ul>
            {uniqueData.usersList.map((user, index) => (
              <li key={index}>{user.approver_name}</li>
            ))}
          </ul>
        ) : (
          "-"
        )
      }
    />,
  ];

  const handleOpenViewItemPopup = (unique_id) => {
    console.log(unique_id);
    let rowData = getUniqueData(processedItemsData, "id", unique_id.id);

    setUniqueData(rowData);
    setOpenViewItemPopup(true);
  };

  const handleEditAddItem = (editData = null) => {
    resetFormFields();

    if (editData) {
      setIsEditMode(true);
      setEditSlabId(editData.id);

      setStageName({ value: editData.slab_name || "", isValid: true });
      setStartPrice({ value: editData.price_start || "", isValid: true });
      SetEndPrice({ value: editData.price_end || "", isValid: true });
      setFromCurrency({
        currency: editData.currency_type || "",
        countryName: editData.country_name || "",
      });

      // 👉 Map ALL users to selectedApprovers (no level splitting)
      const matchedApprovers = editData.usersList
        .map((user) => {
          const match = getuserlist.find(
            (u) =>
              `${u.first_name || ""} - ${u.designation || ""}`.trim() ===
              user.approver_name.trim()
          );
          return match || null;
        })
        .filter(Boolean);

      setSelectedApprovers(matchedApprovers);
      setApprovers([]); // clear dynamic list if not using it
    } else {
      setIsEditMode(false);
      setEditSlabId(null);
    }

    setOpenApprovalModal(true);
  };

  const handleDeleteSlab = async (row) => {
    const formData = new FormData();
    formData.append("id", row.id);
    formData.append("admin_token", user_token);

    try {
      const response = await axios.post(
        API_ENDPOINT.delete_pr_slab_config,
        formData,
        {
          headers: {
            Authorization: `Bearer ${auth_token}`,
          },
        }
      );

      if (response.status === 200) {
        handleGetTWMslab(); // refresh table
      }
    } catch (error) {
      console.error(
        "Error deleting PR slab:",
        error.response?.data || error.message
      );
    }
  };

  return (
    <div className={classes.slab_tab_wrapper}>
      <HeaderTitle titleText={"Invoice Process Approval Matrix"} />

      <div className={classes.search_add_wrapper}>
        <SearchBar
          value={searchQuery}
          onChange={(query) => {
            setSearchQuery(query);
            // setPageNumber(1);
          }}
        />

        <Dbutton
          labelImg={plusIcon}
          iconWidth="1rem"
          iconHeight="1rem"
          label="Invoice APPROVAL MATRIX"
          btnHeight="4rem"
          onClick={handleOpenAddItem}
        />
      </div>

      {/* 553,558 */}

      <div className={classes.d_dataTable}>
        <DataTable
          headings={Tableheadings}
          tableData={filteredData}
          actions={true}
          tableSize={itemsData?.length === 0 ? "100%" : "100%"}
          viewBtn={true}
          sorting={true}
          viewClick={(token, row) => handleOpenViewItemPopup(row)}
          editBtn={true}
          editClick={(token, row) => handleEditAddItem(row)}
          deleteBtn={true}
          deleteClick={(token, row) => handleDeleteSlab(row)}
        />
      </div>

      <Modal
        open={openapprovalmodal}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
        sx={{
          overflow: "auto",
        }}
      >
        <Fade>
          <PopupFrame
            poupHeading={viewUserHeading}
            actionButtons={viewTextActionButtons}
            inputChildren={PoslabItemInputs}
          />
        </Fade>
      </Modal>

      <Modal
        open={openViewItemPopup}
        closeAfterTransition
        slotProps={{
          backdrop: {
            TransitionComponent: Fade,
          },
        }}
      >
        <Fade in={openViewItemPopup}>
          <div
            className={classes.flex}
            style={{
              height: "130vh",
            }}
          >
            <PopupFrame
              inputChildren={viewUserChildren}
              poupHeading={viewUserHeading}
              actionButtons={viewItemsActionButtons}
              closePopup={handleCloseViewItemPopup}
              width={"auto"}
              customClass={classes.addPopup}
              styleCenterDiv={classes.centerDiv}
            />
          </div>
        </Fade>
      </Modal>

      <Modal open={successpopup}>
        <Fade in={successpopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText={`${
                isEditMode
                  ? "PR Approval Slab Updated!!"
                  : "PR Approval Slab Created!!"
              }`}
              popupDescription={`${
                isEditMode
                  ? "PR slab configuration updated successfully"
                  : "PR slab configuration saved successfully"
              }`}
              popBtn={true}
              vendorBtn={true}
              btnText={"Okay"}
              btnClick={handleBack}
            />
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
